import React, {
  forwardRef,
  KeyboardEvent,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { global } from "@shared/libs/Global";
import { checkIsMultiple, getInitPopUp } from "@shared/utils/CommonUtils";
import { callApi, fnGetDataSet } from "@shared/api/restApi";
import SearchPanel from "@widgets/SearchPanel";
import { Button } from "@mui/material";
import SnGrid from "@shared/components/Grid/SnGrid";
import SnResizableLNR from "@shared/components/SnResizableLNR";
import SnResizableUND from "@shared/components/SnResizableUND";
import SnTree from "@shared/components/Grid/SnTree";
import { showDialog } from "@widgets/CommonDialog";

interface EmpPopupProps {
  code: string;
  selectedData?: any;
  modalRef?: any;
  options?: any[];
  autoSearch?: boolean;
}

const EmpPopup = forwardRef(
  (
    { code, selectedData, options, modalRef, autoSearch = true }: EmpPopupProps,
    ref
  ) => {
    const { userInfo } = global();
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns1, setColums1] = useState<any[]>([]);
    const [columns2, setColums2] = useState<any[]>([]);
    const [columns3, setColums3] = useState<any[]>([]);
    const searchRef = useRef<any>(null);
    const treeGridApiRef = useRef<any>(null);
    const gridApiRefH = useRef<any>();
    const gridApiRefL = useRef<any>();
    const [treeDataSource, setTreeDataSource] = useState<any[]>([]);
    const [dataSource1, setDataSource1] = useState<any[]>([]);
    const [dataSource2, setDataSource2] = useState<any[]>([]);
    const [gridFocus, setGridFocus] = useState(false);
    const isMultiple = checkIsMultiple(code) || false;

    const [isInitialized, setIsInitialized] = useState(false);

    const autoGroupColumnDef = {
      headerName: "부서", // 그룹 컬럼의 헤더 이름
      field: "nm_dept", // 데이터를 표시할 필드
      flex: 1,
      filter: "agTextColumnFilter",
      cellRendererParams: {
        suppressCount: true, // 하위 아이템 개수 숨기기
        suppressDoubleClickExpand: true, // 더블 클릭으로 확장/축소 비활성화
        suppressHoverHighlight: false,
      },
    };

    let width1 = "30%";
    const menuSize = localStorage.getItem("menuSize");
    if (menuSize) {
      const menu = JSON.parse(menuSize);
      if (menu.EmpPopup) {
        width1 = menu.EmpPopup.grid1Width ? menu.EmpPopup.grid1Width : width1;
      }
    }
    const [grid1Width, setGrid1Width] = useState<string | number>(width1);

    let height1 = "49%";
    if (menuSize) {
      const menu = JSON.parse(menuSize);
      if (menu.EmpPopup) {
        height1 = menu.EmpPopup.grid1Height
          ? menu.EmpPopup.grid1Height
          : height1;
      }
    }
    const [grid1Height, setGrid1Height] = useState<string | number>(height1);

    useImperativeHandle(ref, () => ({
      getSelectedRow,
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUp(code, {});
          let mergedData = {
            cd_firm: userInfo.cd_firm,
            fg_emp: "",
            cd_emp: "",
            nm_emp: "",
            search: "",
          };
          if (code === "POPUP_RECIPIENT") {
            mergedData.fg_emp = "1";
            mergedData.cd_emp = "";
            mergedData.nm_emp = "";
            mergedData.search = "";
          } else if (code === "POPUP_REFERENCE") {
            mergedData.fg_emp = "2";
            mergedData.cd_emp = "";
            mergedData.nm_emp = "";
            mergedData.search = "";
          }
          const hidecolumns = rtn.grid.grid1.map((column: any) => {
            if (column.field !== "nm_dept") {
              // "nm_dept" 컬럼 외에는 모두 숨기기
              return {
                ...column,
                hide: true,
              };
            }
            return column; // "nm_dept" 컬럼은 그대로 반환
          });

          setFormData(mergedData);
          setFormControlData(rtn.formControlData);
          setColums1(hidecolumns);
          setColums2(rtn.grid.grid2);
          setColums3(rtn.grid.grid3);

          initSearch(mergedData);
        } catch (error) {
          console.log(error);
        }
      };
      fetchform();
    }, [userInfo]);

    useEffect(() => {
      treeGridApiRef.current.selectAndFocusRow(0);
      gridApiRefH.current.selectAndFocusRow(0);
      const selectedRow =
        treeGridApiRef.current.api?.getSelectedNodes()[0].data;
      console.log(dataSource1);
      if (selectedRow) {
        filtering(selectedRow);
      }
      onSearch("init");
      setGridFocus(false);
    }, [gridFocus]);

    useEffect(() => {
      if (!isInitialized) return;

      const firstRow = treeDataSource?.[0];
      setTimeout(() => {
        if (firstRow && dataSource1?.length > 0) {
          filtering(firstRow);
          onSearch("init");
          setIsInitialized(false);
        }
      }, 0);
    }, [isInitialized, treeDataSource, dataSource1]);

    const filtering = (selectedRow: any) => {
      if (!selectedRow) return;

      const cd_dept = selectedRow.cd_dept;
      gridApiRefH.current.applyFilters({ cd_dept: cd_dept });
      gridApiRefH.current.selectAndFocusRow(0);

      const api = gridApiRefH.current.api;
      const rowCount = api.getDisplayedRowCount();
      if (rowCount === 0) return;
    };

    const initSearch = async (mergedData: any) => {
      const fetchdatasource = async () => {
        try {
          const params = {
            id: code.toLowerCase() + "_01",
            params: mergedData ? mergedData : searchRef.current.getFormdata(),
          };

          setTreeDataSource([]);
          setDataSource1([]);
          setDataSource2([]);

          const data: any = await fnGetDataSet(params);

          const transformedData1 = (() => {
            // `cd_dept`를 키로, 항목을 값으로 하는 Map 생성
            const deptMap = new Map(
              data[0].map((item: any) => [item.cd_dept, item])
            );

            return data[0].map((item: any) => {
              const path_arr = [];
              let currentItem = item;

              while (currentItem) {
                if (currentItem.cd_dept === "firm") {
                  path_arr.unshift(currentItem.cd_dept); //unshift 자바스크립트의 배열 메서드(배열 맨 앞에 요소를 추가)
                  break;
                }
                path_arr.unshift(currentItem.cd_dept);
                currentItem = deptMap.get(currentItem.cd_dept_p);
              }
              return {
                ...item,
                path_arr,
              };
            });
          })();
          setTreeDataSource(transformedData1);

          const transformedData2 = data[1].map((d: any) => {
            const isSelected = options?.some((opt: any) => opt.id === d.id);
            return {
              ...d,
              fixCheckbox: isSelected,
            };
          });
          setDataSource1(transformedData2);

          if (options && options.length > 0) {
            setDataSource2(options);
          }

          setIsInitialized(true);
        } catch (error) {
          console.log(error);
        }
      };
      await fetchdatasource();
    };

    const onSearch = async (flag?: string) => {
      // 조회 버튼이지만 실제 db 조회가 아닌 그리드 데이터 필터링 기능
      let cd_emp: any;
      let cd_dept: any;
      const formData = searchRef.current.getFormdata();
      if (flag === "init") {
        cd_emp = userInfo.cd_emp;
        cd_dept = userInfo.cd_dept;
      } else {
        cd_emp = formData?.cd_emp;
      }

      if (flag !== "init" && !cd_emp) {
        await showDialog("alter", "선택된 사원이 없습니다.");
        return;
      }

      if (formData && cd_emp) {
        // cd_firm과 cd_emp로 db에서 cd_dept 조회
        const params = {
          id: code.toLowerCase() + "_02",
          params: { cd_firm: userInfo.cd_firm, cd_emp: cd_emp },
        };

        const result = await fnGetDataSet(params);
        if (result[0].length > 0) {
          cd_dept = result[0][0].cd_dept;
        } else {
          return;
        }
      }

      if (cd_dept) {
        // 부서 코드로 tree focus 변경
        const treeIndex = treeDataSource.findIndex(
          (row: any) => row.cd_dept === cd_dept
        );

        if (treeIndex !== -1) {
          // await new Promise((r) => setTimeout(r, 50)); // 렌더링 대기

          const api = treeGridApiRef.current?.api;
          if (api) {
            api.ensureIndexVisible(treeIndex, "top"); // scroll 이동

            treeGridApiRef.current.selectAndFocusRow(treeIndex); // 포커스

            const selectedRow = api.getSelectedNodes()[0]?.data;
            if (selectedRow) {
              filtering(selectedRow);
            }
          }
        }
      }

      if (cd_emp) {
        // 사원 코드로 grid focus 변경
        const api = gridApiRefH.current?.api;
        if (api) {
          const rowCount = api.getDisplayedRowCount();

          let displayedIndex = -1;
          for (let i = 0; i < rowCount; i++) {
            const row = api.getDisplayedRowAtIndex(i)?.data;
            if (row?.cd_emp === cd_emp) {
              displayedIndex = i;
              break;
            }
          }

          if (displayedIndex !== -1) {
            // await new Promise((r) => setTimeout(r, 50));
            gridApiRefH.current.selectAndFocusRow(displayedIndex);
          }
        }
      }

      if (flag === "init") {
        gridApiRefH.current?.api?.forEachNodeAfterFilter((node: any) => {
          const matched = dataSource1.find((row) => row.id === node.data.id);
          if (matched) {
            node.setDataValue("fixCheckbox", matched.fixCheckbox);
          }
        });
      }
    };

    const handleCellClicked = (event: any) => {
      const selectedRows = gridApiRefH.current.getCheckedRows();
      if (selectedRows.length > dataSource2.length) {
        // 데이터 추가
        setDataSource2(() => {
          const newData = [...dataSource2];
          selectedRows.forEach((row: any) => {
            // fg_emp 넣기 && 새로운 데이터만 추가
            const alreadyExists = newData.some(
              (item: any) => item.id === row.id
            );
            if (!alreadyExists) {
              newData.push({
                ...row,
                fg_emp: code === "POPUP_RECIPIENT" ? "1" : "2",
              });
            }
          });
          return newData;
        });
      } else if (selectedRows.length < dataSource2.length) {
        // 데이터 삭제
        setDataSource2(() => {
          const newData: any[] = [];
          if (selectedRows) {
            dataSource2.forEach((row: any) => {
              if (selectedRows.some((item: any) => item.id === row.id)) {
                newData.push(row);
              }
            });
          } else {
            newData.push(...dataSource2);
          }
          return newData;
        });
      }
    };

    // 공통기능을 사용하면 필터가 되지 않음.
    const onFocusedRowChanged = (event: any) => {
      filtering(event);
    };

    const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
      if (e.key === "Enter") {
        e.preventDefault();
        const focusedCell = gridApiRefH.current?.api.getFocusedCell();
        if (focusedCell) {
          const focusedNode = gridApiRefH.current?.api.getDisplayedRowAtIndex(
            focusedCell.rowIndex
          );
        }
      }
    };

    const getSelectedRow = async () => {
      for (const row of dataSource2) {
        if (
          row.cd_emp === userInfo.cd_emp &&
          formData.cd_emp_admin === userInfo.cd_emp &&
          code === "POPUP_RECIPIENT"
        ) {
          await showDialog(
            "alter",
            "Admin이자 Raised by인데 Recipient가 될 수 없습니다."
          );
          return;
        }
      }

      return dataSource2;
    };

    const onResizeStopT = (width: number) => {
      setGrid1Width(width);
    };

    const onResizeStopH = (height: number) => {
      setGrid1Height(height);
    };

    return (
      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          flex: 1,
          minHeight: 0,
        }}
      >
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div style={{ textAlign: "center" }}>
          <Button
            type="button"
            variant="outlined"
            onClick={() => {
              onSearch();
            }}
            sx={{
              width: 100,
              marginTop: 2,
            }}
          >
            조회
          </Button>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flex: 1,
            minHeight: 0,
            marginTop: 10,
          }}
        >
          <SnResizableLNR
            width={grid1Width}
            minWidth={130}
            onResizeStop={onResizeStopT}
            enable={{ right: true }}
            menuName={"EmpPopup"}
            defaultSize={{ grid2Width: "" }}
          >
            <SnTree
              ref={treeGridApiRef}
              animateRows={false} // 애니메이션 비활성화
              rowData={treeDataSource}
              columnDefs={columns1}
              rowSelection="single"
              onFocusedRowChanged={onFocusedRowChanged}
              suppressNoRowsOverlay={true}
              autoGroupColumnDef={autoGroupColumnDef} // 이건 컬럼설정하는거고
              groupDefaultExpanded={5} // 디폴트로 1개 확장
              getDataPath={(data) => data.path_arr || []}
            />
          </SnResizableLNR>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flex: 1,
              marginLeft: 10,
              width: "auto",
            }}
          >
            <SnResizableUND
              height={grid1Height}
              minHeight={130}
              onResizeStop={onResizeStopH}
              enable={{ bottom: true }}
              menuName={"EmpPopup"}
              defaultSize={{ grid2Height: "" }}
            >
              <div style={{ height: "100%" }} onKeyDown={handleKeyDown}>
                <SnGrid
                  ref={gridApiRefH}
                  columnConfig={columns2} // 컬럼 설정 전달
                  rowData={dataSource1}
                  rowSelection="multiple" // 단일 선택 모드
                  isEditable={false}
                  enableAddRow={false}
                  ischeckboxSelection={true}
                  onCellValueChanged={handleCellClicked}
                  gridOptions={{
                    onFirstDataRendered: () => {
                      const firstRow = treeDataSource?.[0];
                      if (firstRow) {
                        filtering(firstRow);
                        onSearch("init");
                      }
                    },
                    // ...기타 옵션
                  }}
                />
              </div>
            </SnResizableUND>
            <div style={{ flex: 1, minHeight: 0, marginTop: 10 }}>
              <SnGrid
                ref={gridApiRefL}
                columnConfig={columns3} // 컬럼 설정 전달
                rowData={dataSource2}
                rowSelection="multiple" // 단일 선택 모드
                isEditable={false}
                enableAddRow={false}
                ischeckboxSelection={false}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default EmpPopup;
